export default __webpack_public_path__ + "static/user5-113b98c4cb9c957ef3ec13368a65d452.jpg";